import React from "react";
import ContentLoader from "react-content-loader";

export default props =>{
    return <ContentLoader 
        speed={2} 
        viewBox="0 0 400 700"
    >
        <rect x="0" y="0" width="400" height="80" />
        <circle cx="60" cy="140" r="40" />
        <rect x="115" y="110" width="260" height="25" rx="15" />
        <rect x="115" y="150" width="260" height="25" rx="15" />
        <rect x="20" y="190" width="75" height="75" rx="25" />
        <rect x="110" y="190" width="75" height="75" rx="25" />
        <rect x="200" y="190" width="75" height="75" rx="25" />
        <rect x="290" y="190" width="75" height="75" rx="25" />
        <rect x="10" y="280" rx="15" width="380" height="100" />
        <rect x="10" y="395" rx="15" width="380" height="100" />
        <rect x="30" y="510" width="160" height="40" />
        <rect x="210" y="510" width="160" height="40" />
        <rect x="10" y="560" width="380" height="300" />
    </ContentLoader>
}